export enum DeviceMode {
    INPUT = 'input',
    OUTPUT = 'output',
    BOTH = 'both',
}
